<template>
  <Layout>
    <div class="page-header">
      <div class="page-title">
        <h2>{{$t('users_tab')}}</h2>
        <h5>{{$t('manage_users')}}</h5>
      </div>

      <div class="actions">
        <div @click="handleDownloadRequest" class="download-button tooltip-container">
          <img src="@/assets/images/downloadOutline.svg" class="row-item-icon" />
          <span class="tooltip-text">{{$t('download_as_xlsx')}}</span>
        </div>
        <UserFilters />
        <ExpandableSearch />
      </div>
    </div>

    <div class="table-holder">

      <UserTable
          :add-new-user="showAddUserModal"
          :loading="isLoading"
          :users="Array.isArray(tableData.data) ? tableData.data : []"
          :current-sort="currentSort"
          :on-sort="handleSort"
      />

      <div class="pagination-align-center">
        <Pagination :total-items="tableData.total" :per-page="20" :current-page="currentPage" :on-page-change="handlePage"/>
      </div>
      <AddUserModal :visible="addUserModal" :on-hide="hideAddUserModal" :refresh-callback="() => handlePage(1)" :role-list="roleList"/>
    </div>
  </Layout>
</template>

<script>
import BarChart from '@/components/charts/BarChart.vue'
import Layout from "@/components/layouts/Layout.vue";
import AvatarArray from "@/components/AvatarArray.vue";
import UserTable from "@/components/tables/User/UserTable.vue";
import AddUserModal from "@/components/modals/UserModal.vue";
import userService from "@/service/userService";
import Pagination from "@/components/Pagination.vue";
import CompanyTable from "@/components/tables/Company/CompanyTable.vue";
import {handleErrorResponse} from "@/utils/utils";
import roleService from "@/service/roleService";
import LogModal from "@/components/modals/LogModal.vue";
import ExpandableSearch from "@/components/ExpandableSearch.vue";
import UserFilters from "@/components/tables/User/UserFilters.vue";
import TableDownload from "@/components/TableDownload.vue";

export default {
  name: 'Home',
  components: {
    TableDownload,
    UserFilters,
    ExpandableSearch,
    LogModal,
    CompanyTable,
    Pagination,
    AddUserModal,
    UserTable,
    AvatarArray,
    Layout,
    BarChart,
  },
  data() {
    return {
      isLoading: true,
      addUserModal: false,
      data: {},
      tableData: { data: [] },
      currentPage: 1,
      roleList: [],
      currentSort: {
        column: null,
        direction: null
      }
    }
  },
  watch: {
    $route() {
      this.handlePage(1);
    }
  },
  methods: {
    handleSort(column, direction) {
      this.currentSort = {
        column: column,
        direction: direction
      };

      const query = { ...this.$route.query };

      if (column && direction) {
        query.sortBy = column;
        query.sortDirection = direction;
      } else {
        delete query.sortBy;
        delete query.sortDirection;
      }

      this.$router.push({ query });

      this.handlePage(1);
    },
    showAddUserModal() {
      this.addUserModal = true;
    },
    hideAddUserModal() {
      this.addUserModal = false;
    },
    handlePage(page) {
      if (this.isLoading && this.currentPage !== 1) return;
      this.isLoading = true;
      this.currentPage = page;

      const filters = this.getCurrentFilters();

      userService.getUsers(page, filters).then(response => {
        this.data = response.data.data;
        this.tableData = response.data.data.store;
        this.isLoading = false;
      })
    },

    handleDownloadRequest() {
      const filters = this.getCurrentFilters();

      userService.exportUsers(filters)
          .then(response => {
            const blob = new Blob([response.data], {
              type: response.headers['content-type'] || 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });

            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;

            const fileName = `kullanici_raporu_${this.getFormattedDate()}.xls`;
            link.setAttribute('download', fileName);

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

          })
          .catch(error => {
            handleErrorResponse(error, this.$snackbar);
          });
    },

    getFormattedDate() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      return `${year}${month}${day}`;
    },

    getCurrentFilters() {
      const routeQuery = this.$route.query;
      const tempFilters = [];

      if (routeQuery.searchText) {
        tempFilters.push({
          key: 'searchText',
          value: routeQuery.searchText
        });
      }

      if (routeQuery.addedDate) {
        tempFilters.push({
          key: 'addedDate',
          value: routeQuery.addedDate
        });
      }

      if (routeQuery.addedDateEnd) {
        tempFilters.push({
          key: 'addedDateEnd',
          value: routeQuery.addedDateEnd
        });
      }

      if (routeQuery.programNumberMin) {
        tempFilters.push({
          key: 'programNumberMin',
          value: routeQuery.programNumberMin
        });
      }

      if (routeQuery.programNumberMax) {
        tempFilters.push({
          key: 'programNumberMax',
          value: routeQuery.programNumberMax
        });
      }

      if (routeQuery.status) {
        if(routeQuery.status === "1") {
          tempFilters.push({
            key: 'status',
            value: "1"
          })
        }
        else if(routeQuery.status === "0"){
          tempFilters.push({
            key: 'status',
            value: "0"
          })
        }
      }

      if (routeQuery.sortBy && routeQuery.sortDirection) {
        tempFilters.push({
          key: 'orderBy',
          value: [{
            column: routeQuery.sortBy,
            direction: routeQuery.sortDirection
          }]
        });
      }

      return tempFilters;
    }
  },
  mounted() {
    this.isLoading = true;
    const user = JSON.parse(localStorage.getItem('user'));
    roleService.getStoreByCompanyRole(user.companyId).then(response => {
      this.roleList = response.data.data;
    }).catch(err => {
      handleErrorResponse(err, this.$snackbar);
    });

    const routeQuery = this.$route.query;
    if (routeQuery.sortBy && routeQuery.sortDirection) {
      this.currentSort = {
        column: routeQuery.sortBy,
        direction: routeQuery.sortDirection
      };
    }
  }
}
</script>

<style scoped>
.actions{
  flex: 1;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  align-items: center;
}

.icon-title {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 5px;
}

.icon-title span {
  font-family: 'euclid_medium', sans-serif;
  font-size: 18px;
  white-space: nowrap
}

.card {
  margin-bottom: 10px;
}

.icon-holder {
  background-color: #EAECF0;
  border-radius: 8px;
  height: 28px;
  width: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 5px;
}

.icon-holder img {
  cursor: default;
}

.chart-stats {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom: 10px;
}

.chart-value {
  font-family: 'euclid_medium', sans-serif;
  font-size: 28px;
  margin-right: 10px;
}

.chart-percent {
  font-family: 'euclid_semi_bold', sans-serif;
  font-size: 12px;
  margin-left: 5px;
}

.chart-percent.up {
  color: #3DA33E;
}

.chart-percent.down {
  color: #F09460;
}

.table-holder {
  margin-top: 20px;
}

.table-title {
  font-family: 'euclid_medium', sans-serif;
  font-size: 20px;
  color: #040C2D;
  margin-bottom: 20px;
  position: sticky;
}
</style>
